import { useTranslation } from "react-i18next";

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const flagStyle: React.CSSProperties = {
    fontSize: "1.5rem",
  };

  // const selectedLang = i18n.language

  return (
    <div className="">
      <span style={flagStyle} onClick={() => i18n.changeLanguage("en")}>
        🇺🇸
      </span>
      <span style={flagStyle} onClick={() => i18n.changeLanguage("jp")}>
        🇯🇵
      </span>
    </div>
  );
};
